import { render, staticRenderFns } from "./TaskInfoModalClone.vue?vue&type=template&id=7c7cc8d1&scoped=true"
import script from "./TaskInfoModalClone.vue?vue&type=script&lang=js"
export * from "./TaskInfoModalClone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7cc8d1",
  null
  
)

export default component.exports